<template lang="pug">
.container-restricao.row
    .col-8
        small Foram detectadas sobreposições com as seguintes unidades de conservação:

        .list-group
            a.list-group-item.list-group-item-action
                .row.text-left
                    label.col-4 Tipo

                    label.col-7 Nome

            a.list-group-item.list-group-item-action(
                v-for='(restricao, index) in unidadesConservacao.restricoes'
            )
                .row.text-left
                    .col-4
                        span {{ restricao.properties.tipo }}

                    .col-7
                        .text-wrap(
                            data-toggle='tooltip',
                            data-placement='bottom',
                            :title='restricao.properties.nome'
                        ) {{ restricao.properties.nome }}
    .col-4
        mapa(
            v-if='layersMaps',
            :mapLayersConfigs='layersMaps',
            :mapConfig='mapConfig',
            :locked='true',
            :height='"180px"',
            :idMapa='"mapaRestricaoUnidadeConservacao"'
        )
</template>

<script>
import LayerStyle from '../../../utils/layerStyles';

import Mapa from '../../../components/MapaLeaflet';

export default {
    name: 'UnidadesConservacao',

    components: {
        Mapa
    },

    data() {
        return {
            layersMaps: null,
            mapConfig: {
                controls: {
                    fullscreen: true
                }
            }
        };
    },
    props: {
        unidadesConservacao: {
            type: Object,
            required: true
        },

        geometriaAreaMonitorada: {
            type: Object,
            require: true
        }
    },
    methods: {
        configureLayersMapa() {
            this.layersMaps = [];

            let layerAreaMonitorada = {
                style: LayerStyle.AREA_MONITORADA(),
                name: 'Área Monitorada',
                geoJson: this.geometriaAreaMonitorada
            };

            this.layersMaps.push(layerAreaMonitorada);

            this.unidadesConservacao.restricoes.forEach(feature => {
                let layerRestricao = {
                    style: LayerStyle.RESTRICAO(),
                    geoJson: feature.geometry,
                    name: 'Unidades de conservação',
                    tooltip: `${feature.properties.nome}: ${feature.properties.tipo}`
                };

                this.layersMaps.push(layerRestricao);
            });
        }
    },
    mounted() {
        this.configureLayersMapa();
    }
};
</script>
